import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ThemeManagementEffects } from './store/theme-management.effects';
import { ThemeManagementFeature } from './store/theme-management.reducers';

@NgModule({
  providers: [
    provideState(ThemeManagementFeature),
    provideEffects(ThemeManagementEffects),
  ],
})
export class ThemeManagementModule {}
